import React from 'react'
import { Action, IOWidget, mk_widget } from 'widgets-for-react'
import { Id, CMSState } from '../../../../cms/blocks/types.gen'
import { ExtraImages, getImageAttribute } from '../../../utils/extra_images.mod'

import { toRelativeUrl } from '../../../../../helpers'
import { page } from '../../../templates/page.mod'
import { Link } from 'react-router-dom'
import { link, linkWrapper } from '../../../../cms/blocks/utils.gen'
import { WordPress } from '../../../../wordpress/wordpress_api'
import { PublicSite_CustomPageData } from '../../../application.mod'
import { PublicSiteState } from '../../../../public_site.main.mod'
import moment from 'moment'
import { isCustomBlockData } from '../types.mod'
import { ButtonData } from '../../../../wordpress/types_and_parser/extra_types.mod'
import { urlIsExternal } from '../../../../../utils'

export type HeaderAttributes = {
  blockName: 'vidda/header'
  header_type: 'header one' | 'header two'
  title: string
  intro?: string
  image?: WordPress.MediaResponse
  image_mobile?: WordPress.MediaResponse
  primary_button?: ButtonData
  secondary_button?: ButtonData
}

export interface HeaderInterface {
  blockName: 'vidda/header'
  attrs: HeaderAttributes
}

export type HeaderBlockProps<extra_images> = HeaderAttributes

export type HeaderBlockStyle = Partial<{
  block_classname: string
  inner_classname: string
  header_classname: string
  title_classname: string
  content_classname: string
  intro_classname: string
  visual_classname: string
}>

export const StringToHeaderType = (input: string) => (input === 'header one' ? 'header one' : 'header two')

export function HeaderBlock<customBlockData, extra_images>(
  props: HeaderBlockProps<extra_images>,
  options?: { style: HeaderBlockStyle; key?: string }
): (
  s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>
) => IOWidget<PublicSiteState, Action<CMSState<customBlockData, extra_images, PublicSite_CustomPageData>>> {
  return (s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) => (public_state: PublicSiteState) => {
    return mk_widget({
      run: (_) =>
        props.header_type == 'header one'
          ? primaryHeaderBlock<customBlockData, extra_images>(props, options)(s)(public_state).run((_) => {})
          : secondaryHeaderBlock<customBlockData, extra_images>(props, options)(s)(public_state).run((_) => {}),
    })
  }
}

export function primaryHeaderBlock<customBlockData, extra_images>(
  props: HeaderBlockProps<extra_images>,
  options?: { style: HeaderBlockStyle; key?: string }
): (
  s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>
) => IOWidget<PublicSiteState, Action<CMSState<customBlockData, extra_images, PublicSite_CustomPageData>>> {
  return (s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) => (public_state: PublicSiteState) => {
    return mk_widget({
      run: (_) => (
        <header
          className={`hero hero--primary${
            s.custom_page_data &&
            s.custom_page_data.v.kind == 'r' &&
            s.custom_page_data.v.v.post &&
            s.custom_page_data.v.v.post.is_front
              ? ' hero--home'
              : ''
          }
        ${props.image && props.image.media_details && ' hero--has-image'}`}
        >
          <div className="hero__inner">
            <div className="hero__content container--m grid--gutter">
              {props.title && <h1 className="hero__title typo--3xl">{props.title}</h1>}
              <div className="hero__intro">
                {props.intro && (
                  <div className="typo--xs text--styled" dangerouslySetInnerHTML={{ __html: props.intro }} />
                )}
                {(props.primary_button || props.secondary_button) && (
                  <div className="hero__buttons">
                    {props.primary_button &&
                      link(
                        linkWrapper({ title: props.primary_button.text, url: props.primary_button.url }),
                        { classname: 'button button--secondary' },
                        props.primary_button.text,
                        () => {
                          window.dataLayer.push({
                            event: 'event.dubbeldam',
                            category: 'PrimaryHeaderBlock',
                            action: props.primary_button.text,
                            label: window.location.pathname,
                          })
                        }
                      )}

                    {props.secondary_button &&
                      link(
                        linkWrapper({ title: props.secondary_button.text, url: props.secondary_button.url }),
                        { classname: 'button button--secondary' },
                        props.secondary_button.text,
                        () => {
                          window.dataLayer.push({
                            event: 'event.dubbeldam',
                            category: 'PrimaryHeaderBlock',
                            action: props.secondary_button.text,
                            label: window.location.pathname,
                          })
                        }
                      )}
                  </div>
                )}
              </div>
            </div>
            {props.image && props.image.media_details ? (
              <div
                className="hero__visual"
                style={{ backgroundImage: 'url("' + getImageAttribute(props.image, 'header', 'source_url') + '")' }}
              ></div>
            ) : (
              <div className="hero__visual"></div>
            )}
          </div>
        </header>
      ),
    })
  }
}

export function secondaryHeaderBlock<customBlockData, extra_images>(
  props: HeaderBlockProps<extra_images>,
  options?: { style: HeaderBlockStyle; key?: string }
): (
  s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>
) => IOWidget<PublicSiteState, Action<CMSState<customBlockData, extra_images, PublicSite_CustomPageData>>> {
  return (s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) => (public_state: PublicSiteState) => {
    console.log('props', props)
    return mk_widget({
      run: (_) => (
        <header
          className={`hero hero--secondary${
            s.custom_page_data &&
            s.custom_page_data.v.kind == 'r' &&
            s.custom_page_data.v.v.post &&
            s.custom_page_data.v.v.post.is_front
              ? ' hero--home'
              : ''
          }`}
        >
          <div className="hero__inner container--m grid--gutter">
            <div className="hero__content">
              <div className="hero__text">
                {props.title && <h1 className="hero__title typo--2xl">{props.title}</h1>}

                {/* {s.custom_page_data.v.kind == "r" && s.custom_page_data.v.v.post.type == "news" && (
                  <p>
                    {new Date(s.custom_page_data.v.v.post.date).toLocaleString("nl", {
                      day: "numeric",
                      month: "long",
                      year: "numeric",
                    })}
                  </p>
                )} */}

                <div className="hero__intro">
                  {props.intro && (
                    <div className="typo--xs text--styled" dangerouslySetInnerHTML={{ __html: props.intro }} />
                  )}
                  {props.primary_button && (
                    <div className="hero__buttons">
                      {link(
                        linkWrapper({ title: props.primary_button.text, url: props.primary_button.url }),
                        { classname: 'button button--secondary' },
                        props.primary_button.text,
                        () => {
                          window.dataLayer.push({
                            event: 'event.dubbeldam',
                            category: 'SecondaryHeaderBlock',
                            action: props.primary_button.text,
                            label: window.location.pathname,
                          })
                        }
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="hero__visual"></div>
          </div>
        </header>
      ),
    })
  }
}
